<ng-container>
  @if (routerLink) {
    <a
      class="tw-relative tw-flex tw-items-center tw-justify-center focus-visible:tw-outline-2"
      [routerLink]="routerLink"
      [ngClass]="avatarSizeClassMap[size]"
    >
      @if (!useFallback) {
        <img
          [src]="imageUrl"
          [alt]="altText"
          class="tw-h-full tw-w-full tw-rounded-full"
          (error)="onError()"
        />
      } @else {
        <ng-container *ngTemplateOutlet="fallback"></ng-container>
      }

      @if (
        badgeIcon && size !== avatarSize.Small && size !== avatarSize.ExtraSmall
      ) {
        <ng-container *ngTemplateOutlet="badge"></ng-container>
      }
    </a>
  } @else {
    <div class="tw-relative" [ngClass]="avatarSizeClassMap[size]">
      @if (!useFallback) {
        <img
          class="tw-h-full tw-w-full tw-rounded-full"
          [src]="imageUrl"
          [alt]="altText"
          (error)="onError()"
        />
      } @else {
        <ng-container *ngTemplateOutlet="fallback"></ng-container>
      }

      @if (
        badgeIcon && size !== avatarSize.Small && size !== avatarSize.ExtraSmall
      ) {
        <ng-container *ngTemplateOutlet="badge"></ng-container>
      }
    </div>
  }

  <ng-template #fallback>
    <div
      class="tw-relative tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-neutral-300 tw-bg-neutral-100 tw-text-neutral-800"
      [ngClass]="avatarSizeClassMap[size]"
    >
      <da-icon
        [icon]="fallbackIcon ?? 'user'"
        type="solid"
        class="tw-w-2/4"
        [ngClass]="{ 'tw-text-[10px]': size === avatarSize.ExtraSmall }"
        [attr.aria-label]="altText"
      ></da-icon>
    </div>
  </ng-template>

  <ng-template #badge>
    <div
      class="tw-border-neutral-white tw-absolute tw-bottom-0 tw-right-0 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-bg-neutral-800 tw-text-white"
    >
      <da-icon
        [icon]="badgeIcon"
        type="solid"
        class="tw-size-2.5 tw-text-[10px]"
        [attr.aria-label]="badgeAltText"
      ></da-icon>
    </div>
  </ng-template>
</ng-container>
